import React from 'react';
import { TdsAlert, TdsField, TdsButton, TdsButtonContainer } from '@trv-tds/react';
import { ReactComponent as InfoCircle118 } from '@trv-ebus/tds-icons/dist/assets/icons/functional/svg/info-circle-1-18.svg'
import './selectInput.scss'
export const SelectInputWidget = ({ columnWidth = "12", label, options, selectedProduct, setSelectedProduct, validProduct, setValidProduct, highContrastCheck }) => {

    const appliedStyle = highContrastCheck ? '#EF7A00':'#874600'
    const regexMessage = 'Product is required.'
    const handleChange = (e) => {
        let value = e.target.value;
        setSelectedProduct(value);

    }

    const selectInputElem = (
        <div className='selectInput'>
            <TdsField
                label={label}
                className='selectLob'

            >
                <select onChange={handleChange} style={{ color: '#000' }} >
                    {options?.map(function (option, index) {
                        return (
                            <option key={index} value={option} isvalidationerror="true">{option}</option>
                        );
                    })}
                </select>
                {(!validProduct) &&
                   
                    <div style={{ display: "flex", flexDirection: 'row' }}>
                       
                        <div style={{ paddingTop: '4px', marginBottom: '10px', marginLeft: '5px', fontFamily: 'Batterson Sans', fontSize: '14px', fontStyle: 'normal', fontWeight: '600',  color: `${appliedStyle}`  }}>
                            {regexMessage}
                        </div>
                    </div>
                }
            </TdsField>

        </div>
    );

    return (
        <>{selectInputElem}</>
    )
}

export default SelectInputWidget;